import React from "react";
import { FaBug, FaCheckCircle, FaClipboardList } from "react-icons/fa";

const highlights = [
  { icon: <FaBug size={14} />, text: "Breaking things intentionally so users don't have to" },
  { icon: <FaCheckCircle size={14} />, text: "Manual, automated, and API testing across web platforms" },
  { icon: <FaClipboardList size={14} />, text: "Test plans, bug reports, and QA processes from scratch" },
];

const About = () => {
  return (
    <section name="about" className="w-full bg-[#2F4156] py-12">
      <div className="max-w-5xl mx-auto px-6">
        <div className="grid sm:grid-cols-2 gap-16 items-start">
          {/* Left */}
          <div>
            <p className="text-sm font-medium text-[#C8D9E6] tracking-widest uppercase mb-3">
              About
            </p>
            <h2 className="text-4xl font-bold text-[#F5EFEB] leading-tight mb-8">
              I make sure software works the way it should.
            </h2>

            <ul className="flex flex-col gap-4">
              {highlights.map(({ icon, text }) => (
                <li key={text} className="flex items-start gap-3 text-[#C8D9E6] text-sm leading-relaxed">
                  <span className="mt-0.5 shrink-0 text-[#567C8D]">{icon}</span>
                  {text}
                </li>
              ))}
            </ul>
          </div>

          {/* Right */}
          <div className="flex flex-col gap-5 text-[#C8D9E6] leading-relaxed text-base">
            <p>
              I'm Jasper — a QA engineer with a background in product management
              and front-end development. That combination means I don't just test
              in isolation: I understand the product, the user, and the codebase.
            </p>
            <p>
              I've worked across the full testing spectrum — writing test cases,
              setting up automation frameworks (Cypress, Selenium, Playwright),
              validating APIs with Postman, and reporting bugs that actually get
              fixed because I know how to communicate them clearly.
            </p>
            <p>
              My dev background means I can read the code, reproduce edge cases
              faster, and work closely with engineers without translation layers.
            </p>

            <div className="flex gap-4 pt-2">
              <a href="https://www.linkedin.com/in/jasper-manalo-006207126/" target="_blank" rel="noreferrer"
                className="text-sm font-medium text-[#C8D9E6] hover:text-[#F5EFEB] transition-colors">
                LinkedIn →
              </a>
              <a href="https://github.com/jasper1001" target="_blank" rel="noreferrer"
                className="text-sm font-medium text-[#C8D9E6] hover:text-[#F5EFEB] transition-colors">
                GitHub →
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
